import { api } from '@/lib/api-client';
import { hoursToMilliseconds, numberToDuration } from '@/utils/tools';

import { type BanDto, type BanModel } from '../models/ban';

export const createBan = async (playerId: string, updates: Partial<BanModel>) => {
  const params = {
    player_id: +playerId,
    reason_code: updates.reason?.id,
    description: updates.description,
    duration: numberToDuration(hoursToMilliseconds(updates.duration ?? 0)),
    feature_codes: updates.features,
  };
  const response = await api.post<Omit<BanModel, 'id'>>('/v1/ban', params);
  return response.data;
};

export const updateBan = async (id: string, updates: Partial<BanModel>) => {
  await api.put(`/v1/ban/${id}`, {
    description: updates.description,
  });
  return true;
};

export const liftBan = async (id: string, reason: string) => {
  await api.put<BanDto>(`/v1/ban/${id}/status/lift`, {
    reason,
  });
  return true;
};

export const deleteBan = async (id: string) => {
  await api.delete(`/v1/ban/${id}`);
  return true;
};
